'use client';

import type { Spacing } from '@/ui/types';
import cn from 'classnames';
import { HTMLProps } from 'react';
import { Icon } from '../Icon';

import s from './Input.module.css';

type InputSize = 'tiny' | 'small' | 'medium' | 'large';

export type InputProps = {
  width?: number | 'full';
  size?: InputSize;
  spacing?: Spacing;
  hasError?: boolean;
  errorMessage?: string;
  isShowingPassword?: boolean;
  onShowPassword?: () => void;
} & Omit<HTMLProps<HTMLInputElement>, 'size'>;

const Input = ({
  type = 'text',
  className,
  width = 'full',
  size = 'medium',
  spacing,
  hasError,
  errorMessage,
  isShowingPassword,
  onShowPassword,
  disabled,
  ...props
}: InputProps) => {
  const widthInput = width === 'full' ? '100%' : `${width}px`;

  return (
    <div className={cn(s.wrapper, { [`spacing-${spacing}`]: !!spacing })}>
      <div className={s.element}>
        <input
          type={type}
          style={{ width: width ? widthInput : undefined, ...props.style }}
          className={cn(s.input, className, s[size], {
            [s.hasError]: hasError,
            [s.disabled]: disabled,
          })}
          {...props}
        />
        {isShowingPassword && !hasError && (
          <Icon className={s.eye} name="Eye" variant="solid" size={24} onClick={onShowPassword} />
        )}
        {hasError && <Icon variant="solid" name="Warning" color="bloody-500" className={s.icon} />}
      </div>

      <span className={cn(s.error, { [s.active]: hasError && !!errorMessage })}>
        {errorMessage}
      </span>
    </div>
  );
};

export default Input;
